/*global o_util*/

window.o_global = window.o_global || {};

o_global.device = o_global.device || {};

/**
 * Identify the used browser based on the user-agent.
 * The user-agent can be easily manipulated! Use the information with caution.
 *
 * @return {String} Name of the used browser.
 */
o_global.device.browser = (function(findInUserAgent) {
    "use strict";

    // Silk (Amazon Browser)
    if (findInUserAgent("silk")) {
        return "Silk";
    }
    // Iceweasel
    if (findInUserAgent("iceweasel")) {
        return "Iceweasel";
    }
    // NokiaBrowser
    if (findInUserAgent("nokiabrowser") || findInUserAgent("browserng")) {
        return "BrowserNG/NokiaBrowser";
    }
    // Edge
    if (findInUserAgent("edge")) {
        return "Edge";
    }
    // Chrome (iOS/Android)
    if ((findInUserAgent("crios") || findInUserAgent("chrome")) && !findInUserAgent("opera") && !findInUserAgent("opr/")) {
        return "Chrome";
    }
    // Mobile Safari
    if (findInUserAgent("mobile safari") && !findInUserAgent("chrome") && !findInUserAgent("crios") && !findInUserAgent("silk")) {
        return "Mobile Safari";
    }
    // Safari
    if (findInUserAgent("safari") && !findInUserAgent("chrome") && !findInUserAgent("crios") && !findInUserAgent("silk")) {
        return "Safari";
    }
    // Firefox
    if (findInUserAgent("firefox") && !findInUserAgent("seamonkey")) {
        return "Firefox";
    }
    // Internet Explorer
    if (findInUserAgent("msie 9")) {
        return "MSIE9";
    } else if (findInUserAgent("msie 10")) {
        return "MSIE10";
    } else if (findInUserAgent("msie 11") || findInUserAgent("rv:11.0") || findInUserAgent("compatible; MSIE 8.0; Windows NT 6.1; Trident/4.0; Tablet PC 2.0") || findInUserAgent("compatible; MSIE 7.0; Windows NT 6.3; Trident/7.0; Touch")) {
        return "MSIE11";
    } else if (findInUserAgent("msie 8")) {
        return "MSIE8";
    } else if (findInUserAgent("msie")) {
        return "MSIE (not supported Version)";
    }
    // Opera Mini
    if (findInUserAgent("opera mini")) {
        return "Opera Mini";
    }
    // Opera
    if ((findInUserAgent("opera") || findInUserAgent("presto")) || findInUserAgent("opr/")) {
        // Opera Mobile
        if (findInUserAgent("mobile")) {
            return "Opera Mobile";
        } else {
            return "Opera";
        }
    }
    // WebOSBrowser
    if ((findInUserAgent("webos") || findInUserAgent("hpwos")) && (findInUserAgent("webosbrowser") || findInUserAgent("pre/1"))) {
        return "webOSBrowser";
    }
    // SeaMonkey
    if (findInUserAgent("seamonkey")) {
        return "SeaMonkey";
    }

    return "other";
}(o_util.browser.findInUserAgent));
